// Check if PhotoSwipeLightbox is already defined
if (typeof window.PhotoSwipeLightbox === 'undefined') {
  import('https://unpkg.com/photoswipe/dist/photoswipe-lightbox.esm.js')
    .then((module) => {
      window.PhotoSwipeLightbox = module.default;

      // Define custom element after Lightbox is loaded
      definePhotoswipeComponent();
    })
    .catch((error) => {
      console.error('Failed to load PhotoSwipeLightbox:', error);
    });
} else {
  definePhotoswipeComponent();
}

// Function to define the custom element
function definePhotoswipeComponent() {
  if (!customElements.get('photoswipe-component')) {
    customElements.define(
      'photoswipe-component',
      class PhotoswipeComponent extends HTMLElement {
        constructor() {
          super();
          this.defaultOptions = {};

          const settings = this.dataset.pswpOptions;
          if (settings) {
            try {
              this.defaultOptions = JSON.parse(settings);
            } catch (e) {
              console.warn('Invalid JSON in data-pswp-options:', e);
            }
          }

          this.options = {
            ...this.defaultOptions,
            gallery: this,
            pswpModule: () => import('https://unpkg.com/photoswipe')
          };
        }

        connectedCallback() {
          this.initPhotoSwipe();
        }

        initPhotoSwipe() {
          if (window.PhotoSwipeLightbox) {
            this.photoSwipe = new window.PhotoSwipeLightbox(this.options);
            this.photoSwipe.init();
          } else {
            console.error('PhotoSwipeLightbox is not available.');
          }
        }
      }
    );
  }
}